import { getTenant } from '../../../hooks';
import * as sea from 'node:sea';

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};


export const getUsersList = (successCallback, errorCallback, page, search) => {
  const currentTenant = getTenant()
  const queryParam = new URLSearchParams({
    platform_key:currentTenant,
    page,
    query:search
  }).toString()
  const url = process.env.REACT_APP_IBL_DM_URL + '/api/core/platform/users?'+queryParam
   fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  }).then((resp) => {
    resp.json().then((data) => {
      successCallback(data);
      //successCallback({results:USERS_DATASET})
    }).catch(err => {
      errorCallback()
    });
  }).catch(err => {
     errorCallback()
  });
}

export const updateUserStatus = (data, successCallback, errorCallback, userData) => {
  //const currentTenant = getTenant()
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/core/users/platforms/`
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  }).then((resp) => {
    resp.json().then((data) => {
      //successCallback(data);
      successCallback(userData);
    }).catch(err => {
      //errorCallback()
      successCallback(userData);
    });
  }).catch(err => {
    //errorCallback()
    successCallback(userData);
  });
}

export const updateUserRole = (data, successCallback, errorCallback, userData) => {
  //const currentTenant = getTenant()
  const baseURL = process.env.REACT_APP_IBL_STUDIO_URL
  const url = `${baseURL.endsWith("/") ? baseURL : baseURL+'/'}api/ibl/users/manage/roles/`
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      //Authorization: 'Bearer ' + localStorage.getItem('axd_token'),
    },
  }).then((resp) => {
    resp.json().then((role_data) => {
      //successCallback(role_data);
      successCallback(userData)
    }).catch(err => {
      //errorCallback()
      successCallback(userData)
    });
  }).catch(err => {
    //errorCallback()
    successCallback(userData)
  });
}

export const isEmailValid = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const inviteUserByEmail = (email, successCallback, errorCallback) =>{
  const currentTenant = getTenant()
  const url = process.env.REACT_APP_IBL_DM_URL + '/api/catalog/invitations/platform/'
  const data = {
    email:email,
    platform_key:currentTenant,
    source_url:window.location.origin
  }
  fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  }).then((resp) => {
    resp.json().then((data) => {
      successCallback(data);
      //successCallback({results:USERS_DATASET})
    }).catch(err => {
      errorCallback()
    });
  }).catch(err => {
    errorCallback()
  });
}

export const getInvitedUsersList = (successCallback, errorCallback, page, search) => {
  const currentTenant = getTenant()
  const queryParam = new URLSearchParams({
    platform_key:currentTenant,
    page,
    query:search
  }).toString()
  const url = process.env.REACT_APP_IBL_DM_URL + '/api/catalog/invitations/platform?'+queryParam
  fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Token ' + localStorage.getItem('dm_token'),
    },
  }).then((resp) => {
    resp.json().then((data) => {
      successCallback(data);
      //successCallback({results:USERS_DATASET})
    }).catch(err => {
      errorCallback()
    });
  }).catch(err => {
    errorCallback()
  });
}

export const USERS_DATASET = [
  {
    "user_id": 1,
    "username": "alex01",
    "email": "alex01@example.com",
    "name": "Alex Johnson",
    "platform_key": "alex01",
    "platform_org": "1001001001",
    "added_on": "2024-05-23T14:22:11.410723Z",
    "expired_on": null,
    "is_admin": true,
    "is_staff": false,
    "active": true
  },
  {
    "user_id": 2,
    "username": "bella02",
    "email": "bella02@example.com",
    "name": "Bella Thompson",
    "platform_key": "bella02",
    "platform_org": "1002001002",
    "added_on": "2024-03-15T09:45:30.410723Z",
    "expired_on": null,
    "is_admin": false,
    "is_staff": true,
    "active": true
  },
  {
    "user_id": 3,
    "username": "charlie03",
    "email": "charlie03@example.com",
    "name": "Charlie Brown",
    "platform_key": "charlie03",
    "platform_org": "1003001003",
    "added_on": "2024-01-05T12:30:45.410723Z",
    "expired_on": null,
    "is_admin": true,
    "is_staff": true,
    "active": true
  },
  {
    "user_id": 4,
    "username": "dana04",
    "email": "dana04@example.com",
    "name": "Dana White",
    "platform_key": "dana04",
    "platform_org": "1004001004",
    "added_on": "2024-04-10T08:12:55.410723Z",
    "expired_on": null,
    "is_admin": false,
    "is_staff": false,
    "active": false
  },
  {
    "user_id": 5,
    "username": "evan05",
    "email": "evan05@example.com",
    "name": "Evan Green",
    "platform_key": "evan05",
    "platform_org": "1005001005",
    "added_on": "2024-02-14T10:25:34.410723Z",
    "expired_on": null,
    "is_admin": true,
    "is_staff": false,
    "active": true
  },
  {
    "user_id": 6,
    "username": "fay06",
    "email": "fay06@example.com",
    "name": "Fay Adams",
    "platform_key": "fay06",
    "platform_org": "1006001006",
    "added_on": "2024-03-30T07:55:20.410723Z",
    "expired_on": null,
    "is_admin": false,
    "is_staff": true,
    "active": false
  },
  {
    "user_id": 7,
    "username": "george07",
    "email": "george07@example.com",
    "name": "George Martin",
    "platform_key": "george07",
    "platform_org": "1007001007",
    "added_on": "2024-05-01T11:45:10.410723Z",
    "expired_on": null,
    "is_admin": true,
    "is_staff": true,
    "active": true
  },
  {
    "user_id": 8,
    "username": "hannah08",
    "email": "hannah08@example.com",
    "name": "Hannah Lee",
    "platform_key": "hannah08",
    "platform_org": "1008001008",
    "added_on": "2024-02-28T06:30:55.410723Z",
    "expired_on": null,
    "is_admin": false,
    "is_staff": false,
    "active": false
  },
  {
    "user_id": 9,
    "username": "ivan09",
    "email": "ivan09@example.com",
    "name": "Ivan Clark",
    "platform_key": "ivan09",
    "platform_org": "1009001009",
    "added_on": "2024-06-12T13:15:47.410723Z",
    "expired_on": null,
    "is_admin": true,
    "is_staff": false,
    "active": true
  },
  {
    "user_id": 10,
    "username": "jane10",
    "email": "jane10@example.com",
    "name": "Jane Miller",
    "platform_key": "jane10",
    "platform_org": "1010001010",
    "added_on": "2024-01-20T15:55:38.410723Z",
    "expired_on": null,
    "is_admin": false,
    "is_staff": true,
    "active": true
  },
  {
    "user_id": 11,
    "username": "kyle11",
    "email": "kyle11@example.com",
    "name": "Kyle Wilson",
    "platform_key": "kyle11",
    "platform_org": "1011001011",
    "added_on": "2024-04-05T10:22:33.410723Z",
    "expired_on": null,
    "is_admin": true,
    "is_staff": true,
    "active": false
  },
  {
    "user_id": 12,
    "username": "laura12",
    "email": "laura12@example.com",
    "name": "Laura Martinez",
    "platform_key": "laura12",
    "platform_org": "1012001012",
    "added_on": "2024-06-07T09:14:21.410723Z",
    "expired_on": null,
    "is_admin": false,
    "is_staff": false,
    "active": true
  },
  {
    "user_id": 13,
    "username": "mike13",
    "email": "mike13@example.com",
    "name": "Mike Taylor",
    "platform_key": "mike13",
    "platform_org": "1013001013",
    "added_on": "2024-05-18T07:45:12.410723Z",
    "expired_on": null,
    "is_admin": true,
    "is_staff": false,
    "active": false
  },
  {
    "user_id": 14,
    "username": "nina14",
    "email": "nina14@example.com",
    "name": "Nina Harris",
    "platform_key": "nina14",
    "platform_org": "1014001014",
    "added_on": "2024-03-22T08:20:34.410723Z",
    "expired_on": null,
    "is_admin": false,
    "is_staff": true,
    "active": true
  },
  {
    "user_id": 15,
    "username": "oliver15",
    "email": "oliver15@example.com",
    "name": "Oliver Robinson",
    "platform_key": "oliver15",
    "platform_org": "1015001015",
    "added_on": "2024-04-13T12:12:10.410723Z",
    "expired_on": null,
    "is_admin": true,
    "is_staff": true,
    "active": true
  },
  {
    "user_id": 16,
    "username": "paul16",
    "email": "paul16@example.com",
    "name": "Paul Lewis",
    "platform_key": "paul16",
    "platform_org": "1016001016",
    "added_on": "2024-02-05T13:55:45.410723Z",
    "expired_on": null,
    "is_admin": false,
    "is_staff": false,
    "active": false
  },
  {
    "user_id": 17,
    "username": "quinn17",
    "email": "quinn17@example.com",
    "name": "Quinn Walker",
    "platform_key": "quinn17",
    "platform_org": "1017001017",
    "added_on": "2024-01-10T14:35:22.410723Z",
    "expired_on": null,
    "is_admin": true,
    "is_staff": false,
    "active": true
  },
  {
    "user_id": 18,
    "username": "rose18",
    "email": "rose18@example.com",
    "name": "Rose Hall",
    "platform_key": "rose18",
    "platform_org": "1018001018",
    "added_on": "2024-06-19T11:35:01.410723Z",
    "expired_on": null,
    "is_admin": false,
    "is_staff": true,
    "active": true
  },
  {
    "user_id": 19,
    "username": "sam19",
    "email": "sam19@example.com",
    "name": "Sam Young",
    "platform_key": "sam19",
    "platform_org": "1019001019",
    "added_on": "2024-03-29T12:12:10.410723Z",
    "expired_on": null,
    "is_admin": true,
    "is_staff": true,
    "active": false
  },
  {
    "user_id": 20,
    "username": "tina20",
    "email": "tina20@example.com",
    "name": "Tina Allen",
    "platform_key": "tina20",
    "platform_org": "1020001020",
    "added_on": "2024-02-14T13:55:45.410723Z",
    "expired_on": null,
    "is_admin": false,
    "is_staff": false,
    "active": true
  }
]
